import type React from 'react';

/** The help paragraph under a step's heading. */
export const helpText: React.CSSProperties = { fontSize: 13, color: 'var(--text-muted)', marginBottom: 16, lineHeight: 1.5 };
